<div *ngIf="reportGenerationForm != null" [formGroup]="reportGenerationForm">
  <div class="row">
    <div class="col-12 col-md-4">
      <label>Tax Agencies</label>
      <select class="form-control" id="timeframe" formControlName="taxAgency">
        <option [value]="null" disabled>Please Select an Agency</option>
        <option *ngFor="let agency of taxAgencies" [value]="agency">{{ agency }}</option>
      </select>
    </div>
    <div class="col-12 col-md-4">
      <label>Year/Quarter</label>
      <lib-quarter-picker
        [validQuarters]="validQuarters"
        class="d-block"
        [minimumValue]="minimumValue"
        [maximumValue]="maximumValue"
        formControlName="quarter"></lib-quarter-picker>
    </div>
  </div>
</div>
<lib-report-buttons
  *ngIf="reportGenerationForm != null"
  [disabled]="reportGenerationForm.invalid"
  (generateReport)="generateReport()"
  (downloadReport)="downloadReport($event)"></lib-report-buttons>
